import AdminPagination from "./admin-pagination";

export default AdminPagination